export default function CalendarForecastValue({ event }) {
  const components = event.forecast_components || [];
  const source = event.forecast_source === "mt5_calendar" ? "MetaTrader 5" : event.forecast_source;
  if (event.forecast !== null && event.forecast !== undefined && event.forecast !== "") {
    return <span title={source ? "Forecast supplied by " + source : undefined}>{event.forecast}</span>;
  }
  if (components.length) {
    const details = components.map(item => item.name + ": " + item.forecast).join("\n");
    return <span title={details + "\nSource: MetaTrader 5"}>{components.length} forecasts</span>;
  }
  return <span>—</span>;
}
